import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import './rxjs-extensions';
import { ExternalUserComponent } from './external-user/external-user.component';
import { AdminComponent } from './admin/admin.component';
import { LandingComponent } from './landing.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { RefundApproveComponent } from './refund-approve/refund-approve.component';
import { AccountExecutiveComponent } from './account-executive/account-executive.component';
// Primeng
import { ChartModule } from 'primeng/chart';
import { EditorModule } from 'primeng/editor';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { Textarea } from 'primeng/textarea';
import { TabsModule } from 'primeng/tabs';
import { DialogModule } from 'primeng/dialog';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AdvanceDetailsComponent } from '@advancedetailcompenent/advance-details.component';
import { InvoiceDetailsComponent } from './external-user/invoice-details/invoice-details.component';
import { OrderDetailsComponent } from './external-user/order-details/order-details.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HttpClientService } from '@authmanager/requestManager';
import { authManager } from '@authmanager/authManager';
import { AuthService } from './service/auth.service';
import { AdminService } from '@adminservice/admin.service';
import { AnnouncementComponent } from './announcement/announcement.component';
import { HeaderService } from '@headerservice/header.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExternalloginComponent } from './externallogin/externallogin.component';
import { ExternalRegistrationComponent } from './external-registration/external-registration.component';
import { DatePipe } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { InputMaskModule } from 'primeng/inputmask';
import { ExternalChangePassword } from './externalchangepassword/externalchangepassword.component';
import { ExternalForgotPasswordComponent } from './external-forgot-password/external-forgot-password.component';

import { BlockCopyPasteDirective } from './shared/block-copy-paste.directive';
import { LogoutComponent } from './logout/logout.component';
import { AdvancePaymentStatusComponent } from '@advancedetailcompenent/advance-payment-status/advance-payment-status.component';
import { OrderInvoiceDetailsComponent } from './external-user/order-invoice-details/order-invoice-details.component';
import { OrderInvoiceStatusComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status.component';
import { RefundStatusComponent } from './refund-approve/refund-status/refund-status.component';
import { ChaseGatewayComponent } from './chase-gateway/chase-gateway.component';
import { InvoiceStatusComponent } from './external-user/invoice-details/invoice-status/invoice-status.component';
import { OrderStatusComponent } from './external-user/order-details/order-status/order-status.component';
import { InvoiceStatusProfileComponent } from './external-user/invoice-details/invoice-status/invoice-status-profile/invoice-status-profile.component';
import { OrderInvoiceStatusProfileComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status-profile/order-invoice-status-profile.component';
import { OrderStatusProfileComponent } from './external-user/order-details/order-status/order-status-profile/order-status-profile.component';
import { AdvancePaymentStatusProfileComponent } from '@advancedetailcompenent/advance-payment-status/advance-payment-status-profile/advance-payment-status-profile.component';
//import { InternalinvoiceComponent } from './internalinvoice/internalinvoice.component';

//import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { UserTypeGuard } from './user-type.guard';

import { FooterComponent } from './footer/footer.component';
import { ChaseTransactionLogsComponent } from './chase-transaction-logs/chase-transaction-logs.component';
import { ChaseTransactionLogsService } from './chase-transaction-logs/Service/chase-transaction-logs-service';
import { AgencyComponent } from './admin/agency/agency.component';
import { AgencyService } from './admin/agency/Service/agency.service';
import { GetEnvVarService } from './service/get-env-var.service';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { InternalinvoiceComponent } from './internalinvoice/internalinvoice.component';
// import { FullCalendarModule } from '@fullcalendar/angular';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
export const MyCustomBluePreset = definePreset(Lara, {
    
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}', // This is the main brand color
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{blue.600}',
                    hoverColor: '{blue.700}',
                    activeColor: '{blue.800}'
                }
            }
        }
    }
});
@NgModule({ declarations: [
        AppComponent,
        AdminComponent,
        HeaderComponent,
        ExternalUserComponent,
        AdvanceDetailsComponent,
        InvoiceDetailsComponent,
        OrderDetailsComponent,
        LandingComponent,
        AnnouncementComponent,
        RefundApproveComponent,
        ExternalloginComponent,
        ExternalRegistrationComponent,
        AccountExecutiveComponent,
        ExternalChangePassword,
        ExternalForgotPasswordComponent,
        BlockCopyPasteDirective,
        LogoutComponent,
        AdvancePaymentStatusComponent,
        OrderInvoiceDetailsComponent,
        OrderInvoiceStatusComponent,
        RefundStatusComponent,
        ChaseGatewayComponent,
        InvoiceStatusComponent,
        OrderStatusComponent,
        InvoiceStatusProfileComponent,
        OrderInvoiceStatusProfileComponent,
        OrderStatusProfileComponent,
        AdvancePaymentStatusProfileComponent,
        InternalinvoiceComponent,
        FooterComponent,
        ChaseTransactionLogsComponent,
        AgencyComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule, BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule, ReactiveFormsModule,
        // NgbModule,
        // Primeng
        TableModule,
        ButtonModule, SelectModule, Textarea, TabsModule, DialogModule,
        KeyFilterModule, MessageModule, ConfirmDialogModule, ToastModule,
        DatePickerModule, CheckboxModule, AutoCompleteModule,
        ScrollPanelModule,
        MatTooltipModule,
        InputMaskModule, ProgressSpinnerModule, ChartModule, EditorModule, InputTextModule, TooltipModule], providers: [authManager, AuthService, HttpClientService, NoopAnimationsModule, AdminService, HeaderService, DatePipe, AgencyService, GetEnvVarService, provideHttpClient(withInterceptorsFromDi())
            
            ,provideAnimationsAsync(), 
            providePrimeNG(
            { 
                theme: { 
                preset: MyCustomBluePreset,
                options: {
                    cssLayer: {
                        name: 'primeng',
                        order: 'primeng, custom-styles'
                    }
                } 
            }
        
        })
    ] })
export class AppModule { }
